import type { FaireProductEntity } from "../../entity_types/product";

export const p_k7yxvzm9vc: FaireProductEntity = {
  token: "p_k7yxvzm9vc",
  type: "product",
  name: "Natural Incense Smudge Sticks - Palo Santo (15 grams)",
  brandToken: "b_89kf2nlsjr",
  brandName: "Designs by Deekay Inc.",
  imageUrl:
    "https://cdn.faire.com/fastly/e816b9fad8cf3eed5c95682303c8b369b1cb6a32beb13843deb73d1c971cd324.jpeg",
  galleryImageUrls: [],
  priceDollars: 1.8,
  description:
    "Natural Incense Smudge Sticks - Palo Santo (15 grams)\n \n PRODUCT SPECS\n • Weight: 15 grams per pack\n • Format: Natural incense smudge sticks\n • Burn Time: Approximately 1 hour\n • Material: Handcrafted with herbs and incense ingredients\n • Origin: Handcrafted in India\n \n RETAIL PERFORMANCE\n • Hybrid incense/smudging format adds assortment variety\n • Compact pack works well for impulse and add-on placement\n • Palo Santo profile is a dependable seller in cleansing categories\n • Easy cross-merchandise with burners, bowls, and cleansing kits\n • Supports repeat purchase in incense-focused retail",
  tags: [],
  msrpDollars: 3.6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:14.552Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
